import { useParams } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import "../styles/transactdesign.css";
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const TransactDetails = () => {
    const { getTransactionById } = useContext(AuthContext);
    const { id } = useParams();
    const [transaction, setTransaction] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchTx = async () => {
            const res = await getTransactionById(id);
            console.log(res);
            if (res?.transaction) {
                setTransaction(res.transaction);
            } else {
                setError(res?.message || "Failed to load transaction.");
            }
            setLoading(false);
        };

        fetchTx();
    }, [id]);

    if (loading) return <p>Loading transaction details...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!transaction) return <p>No transaction found.</p>;

    const isCredit = transaction.type === "deposit" || transaction.type === "Approved";
    const formattedAmount = `${isCredit ? '+' : '-'}₦${Number(transaction.amount).toLocaleString()}`;
    const statusIcon = transaction.status === "Successful" || transaction.status === "Completed";
    const resolvedBankName = transaction.bankName || "";
    const resolvedAccountName = transaction.accountName || "";

    const getSender = () => {
        return transaction.sender || transaction.accountName || "BLESSED SIDEN";
    };

    const getTransactionDescription = () => {
        const tx = transaction;


        switch (tx.type) {
            case "buy-airtime":
                return `AIRTIME ${tx.network?.toUpperCase() || ""} ${tx.phoneNumber || ""}`;
            case "generate-epin":
                return `EPIN ${tx.network || ""} ₦${tx.denomination} x${tx.quantity}`;
            case "buy-data":
                return `DATA ${tx.network?.toUpperCase() || ""} ${tx.phoneNumber || ""}`;
            case "buy-cabletv":
                return `CABLE ${tx.service_id?.toUpperCase() || ""} ${tx.smartcard_number || ""}`;
            case "deposit":
                return `WALLET FUNDING`;
            case "withdrawal":
                return `WITHDRAWAL TO ${tx.bankName?.toUpperCase() || ""} FROM ${tx.payeeName?.toUpperCase() || ""}`;
            case "buy-education":
                return `${tx.package?.toUpperCase() || ""}`;
            case "pay-electricity":
                return `ELECTRICITY ${tx.service?.toUpperCase() || ""} ${tx.meterNumber || ""} ${tx.meterType?.toUpperCase() || ""}`;
            case "airtime-to-cash":
                return `AIRTIME TO CASH`;
            case "bulk-sms":
                return `BULK SMS FROM ${tx.sender?.toUpperCase() || ""}`;
            case "Approved":
                return `APPROVED`;
            default:
                return `TRANSACTION`;
        }
    };

    return (
        <div className="transaction-detail-page">
            {/* Top Card */}
            <div className="top-card">
                <div className="sender">{getTransactionDescription()}</div>
                <h1 className={`amount ${isCredit ? 'credit' : 'debit'}`}>{formattedAmount}</h1>
                <div className="status-icon">
                    {statusIcon ? <FaCheckCircle className="success" /> : <FaTimesCircle className="fail" />}
                    <span className="status-text">{transaction.status.toUpperCase()}</span>
                </div>

            </div>

            {/* Bottom Card */}
            <div className="bottom-card">
                <div className="details-row">
                    <div className="label">Description</div>
                    <div className="value">{getTransactionDescription()}</div>
                </div>
                <div className="details-row">
                    <div className="label">Transaction Type</div>
                    <div className="value">{transaction.type.replace(/-/g, ' ').toUpperCase()}</div>
                </div>
                <div className="details-row">
                    <div className="label">Completing Time</div>
                    <div className="value">
                        {new Intl.DateTimeFormat('en-NG', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true,
                            timeZone: 'Africa/Lagos'
                        }).format(new Date(transaction.timestamp))}
                        ,{" "}
                        {new Intl.DateTimeFormat('en-NG', {
                            month: 'short',
                            day: '2-digit',
                            year: 'numeric',
                            timeZone: 'Africa/Lagos'
                        }).format(new Date(transaction.timestamp))}
                    </div>
                </div>

                <div className="details-row">
                    <div className="label">Transaction ID</div>
                    <div className="value">{transaction._id}</div>
                </div>

                {/* Optional Additional Fields */}
                {transaction.type === "deposit" && (
                    <>
                        {transaction.payeeName && (
                            <div className="details-row"><span className="label">Payee Name</span><span className="value">{transaction.payeeName}</span></div>
                        )}
                        {transaction.orderId && (
                            <div className="details-row"><span className="label">Order ID</span><span className="value">{transaction.orderId}</span></div>
                        )}
                        {transaction.remark && (
                            <div className="details-row"><span className="label">Remark</span><span className="value">{transaction.remark}</span></div>
                        )}
                        {transaction.currency && (
                            <div className="details-row"><span className="label">Currency</span><span className="value">{transaction.currency}</span></div>
                        )}
                    </>
                )}

                {transaction.type === "withdrawal" && (
                    <>
                        <div className="details-row">
                            <span className="label">Bank Name</span>
                            <span className="value">{transaction.bankName?.toUpperCase() || "N/A"}</span>
                        </div>
                        <div className="details-row">
                            <span className="label">Account Name</span>
                            <span className="value">{transaction.payeeName?.toUpperCase() || "N/A"}</span>
                        </div>
                        <div className="details-row">
                            <span className="label">Account Number</span>
                            <span className="value">{transaction.accountNumber || "N/A"}</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default TransactDetails;
